import { LeadsDataService } from '../services/leads/leads-data.service';
import { LeadDocumentsModel, LeadsQueryRequest } from '../models/leads/leads.model';
import { Subject } from "rxjs";
import { HideLoader, ShowLoader } from "../app/store/loader/loader.actions";

export class DownloadHelper {

  static isInProgress: boolean = false
  static downloadStarted: Subject<boolean> = new Subject<boolean>();
  static downloadFinished: Subject<boolean> = new Subject<boolean>();
  static interval: any;

  static downloadDocuments(leadId: number, leadsDataService: LeadsDataService) {
    leadsDataService.downloadLeadDocuments(leadId).subscribe(({data, success}) => {
      if (success) {
        this.downloadBlob(data, 'All documents.zip');
      }
    });
  }

  static downloadDocument(doc: LeadDocumentsModel, leadsDataService: LeadsDataService, newTab = false): boolean {
    leadsDataService.downloadLeadDocument(doc.Id).subscribe( ({data, success}) => {
      if (success) {
        newTab = newTab && (
            doc.MimeType.startsWith('audio/') ||
            doc.MimeType.startsWith('video/') ||
            doc.MimeType.startsWith('image/') ||
            doc.MimeType.endsWith('/pdf') ||
            doc.MimeType === 'text/plain') &&
            !(
                !window.navigator.userAgent.includes('Chrome') &&
                window.navigator.userAgent.includes('Safari/') &&
                (
                    window.navigator.userAgent.includes('iPhone') ||
                    window.navigator.userAgent.includes('iPad') ||
                    window.navigator.userAgent.includes('Mobile') ||
                    window.navigator.userAgent.match(/\bVersion\/(\d+(\.\d+)?)/) === null ||
                    parseFloat(window.navigator.userAgent.match(/\bVersion\/(\d+(\.\d+)?)/)[1]) < 14
                )
            );
        this.downloadBlob(data, doc.Name, newTab);
      }
    });

    return false;
  }


  static downloadSearchedLeadByIds(leadsDataService: LeadsDataService, leadIds: number[]): boolean {
    leadsDataService.downloadSearchedLeadByIds(leadIds).subscribe( ({data, success}) => {
      if (success) {
        this.downloadBlob(data, 'Anfragenliste.xlsx');
      }
    });

    return false;
  }

  static downloadQueryLeads(leadsDataService: LeadsDataService, request: LeadsQueryRequest): boolean {
    leadsDataService.queryLeadsDownload(request).subscribe( ({data, success}) => {
      if (success) {
        this.downloadBlob(data, 'Anfragenliste.xlsx');
      }
    });

    return false;
  }

  static downloadLead(id: number, leadsDataService: LeadsDataService): boolean {
    leadsDataService.downloadLead(id).subscribe( ({data, success}) => {
      if (success) {
        this.downloadBlob(data, 'Anfragenliste.xlsx');
      }
    });

    return false;
  }

  private static downloadBlob(data: Blob, name: string, newTab = false): void {
    DownloadHelper.downloadStarted.next(true);
    DownloadHelper.interval = setInterval(()=> {
      DownloadHelper.downloadStarted.next(true)
    },5000)
    const link = document.createElement('a');
    link.href = URL.createObjectURL(data);

    if (newTab) {
      link.target = '_blank';
    } else {
      const ext = name.split('.')[1];
      const fileName = name.split('.')[0];
      const day = `0${new Date().getDate()}`.slice(-2);
      const month = `0${new Date().getMonth() + 1}`.slice(-2);
      const year = new Date().getFullYear()
      link.download = fileName + '_' + year + '-' + month + '-' + day + '.' + ext;
    }

    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    }, 10000);

    DownloadHelper.downloadFinished.next(true)
  }
}
